import React from "react";
import { Navigate } from "react-router-dom";
import { getBasePath } from "../../utils";

const StoreCouponsPage = () => (
  <Navigate to={`${getBasePath()}/admin/dashboard?tab=coupons`} replace />
);

export default StoreCouponsPage;
